import { defineComponent } from 'vue'
import IntegrationsDetailMixin from './integrationsDetailMixin'

export type JiraConfigOptions = Array<{ id: string; name: string }>
export type SelectOptions = Array<{ value: string; label: string }>
export type JiraConfig = {
  _rel?: {
    cloud_id?: Record<
      string,
      {
        project_key?: JiraConfigOptions
      }
    >
    project_key?: Record<
      string,
      {
        issue_type?: JiraConfigOptions
      }
    >
  }
  cloud_id?: JiraConfigOptions
}

export default defineComponent({
  name: 'JiraIntegrationMixin',
  mixins: [IntegrationsDetailMixin],
  data() {
    return {
      selectedCloudId: '',
      selectedProject: '',
      selectedIssueType: '',
      integrationOptions: {
        _rel: {
          cloud_id: {},
          project_key: {}
        },
        cloud_id: []
      } as JiraConfig
    }
  },
  computed: {
    installedOn(): string {
      const opts = this.cloudIdOptions.filter(
        (opt) => opt.value === this.integration.settings.cloud_id
      )[0]

      if (opts) {
        return opts.label
      }

      return ''
    },
    isProjectValid(): boolean {
      return this.projectOptions.some((project) => project.value === this.selectedProject)
    },
    isIssueTypeValid(): boolean {
      return this.issueTypeOptions.some((issueType) => issueType.value === this.selectedIssueType)
    },
    selectedCloudName(): string {
      if (this.selectedCloudId) {
        const { label } = this.cloudIdOptions.filter((opt) => opt.value === this.selectedCloudId)[0]
        return label
      }

      return ''
    },
    cloudIdOptions(): SelectOptions {
      return this.generateOptionsFromConfig(this.integrationOptions?.cloud_id)
    },
    projectOptions(): SelectOptions {
      return this.generateOptionsFromConfig(
        this.integrationOptions?._rel?.cloud_id?.[this.selectedCloudId]?.project_key
      )
    },
    issueTypeOptions(): SelectOptions {
      // Epic is not really an issue type, and intializing it won't make sense for
      // our use case, filtering it out of the valid options
      return this.generateOptionsFromConfig(
        this.integrationOptions?._rel?.project_key?.[this.selectedProject]?.issue_type
      ).filter((option) => option.label.toLowerCase() !== 'epic')
    }
  },
  methods: {
    validateJiraConfig(): void {
      if (!(this.selectedCloudId && this.selectedProject && this.selectedIssueType)) {
        throw new Error('Please select all the configuration options.')
      }

      if (!this.isProjectValid) {
        throw new Error(`The selected project does not belong to ${this.selectedCloudName}.`)
      }

      if (!this.isIssueTypeValid) {
        throw new Error(`The selected issue type does not belong to the ${this.selectedCloudName}.`)
      }
    },
    generateOptionsFromConfig(options?: JiraConfigOptions): SelectOptions {
      return Array.isArray(options)
        ? options.map((opt) => {
            return { value: opt.id, label: opt.name }
          })
        : []
    }
  }
})
